import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

const MY_ICONS = {
    home: '@/static/icons/home.svg',
    stockPercent: '@/static/icons/stock.svg',

}

export default new Vuetify({
    icons: {
        values: MY_ICONS,
    },
    theme: {
        themes: {
            light: {
                primary: '#0156AD',
                secondary: '#ACB7C0',
            },
        },
    },
    lang: {
        locales: ['ru'],
        current: 'ru',

    }
});

